import React from 'react'
import { Typography, Card, Layout, Divider, Row, Col } from 'antd'
import { Container } from '../../styles'
import PoweredBy from '../find-order/powered-by'
import FindOrderForm from '../find-order/find-order-form'
import styled from 'styled-components'

const StyledTitle = styled(Typography.Title)`
  margin: 0;
`

export default function FindOrderPage() {
  return (
    <Container data-testid="find-order-form">
      <Card>
        <Layout.Content style={{ overflow: 'initial', padding: '0 12px' }}>
          <Row justify="center">
            <Col>
              <StyledTitle level={2}>Track your order</StyledTitle>
            </Col>
          </Row>
          <FindOrderForm />
          <Divider />
          <PoweredBy />
        </Layout.Content>
      </Card>
    </Container>
  )
}
